import { Spin } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';
import React from 'react';
import styled from 'styled-components';

const LoadingSpinnerContainer = styled.div`
    display: flex;
    width: 100%;
    height: 100%;
    text-align: center;
`;

interface LoadingSpinnerProps {
    spinColour?: string;
}

const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({ spinColour }) => (
    <LoadingSpinnerContainer>
        <Spin
            indicator={
                <LoadingOutlined
                    style={{
                        width: 'auto',
                        height: 'auto',
                        fontSize: 96,
                        color: `${spinColour ? spinColour : 'white'}`,
                    }}
                    spin
                />
            }
            style={{
                margin: 'auto',
                width: 'auto',
                height: 'auto',
            }}
        />
    </LoadingSpinnerContainer>
);

export default LoadingSpinner;
